module.exports = __webpack_public_path__ + "img/il_Onboarding_Explore.f7233418.svg";